export class HasParentOrderedDuringActiveMonth {
    public static readonly type = '[Orders] has parent orderd during active month';
    constructor(public hasHomeworkOrders: boolean, public hasMealOrders: boolean) {}
}

export class SetParentMealReservationInActiveMonth {
    public static readonly type = '[Orders] SetParentMealReservationInActiveMonth';
}

export class SetParentHomeworkReservationInActiveMonth {
    public static readonly type = '[Orders] SetParentHomeworkReservationInActiveMonth';
}

export class ResetOrdersDuringActiveMonth {
    public static readonly type = '[Orders] reset orders during active month';
}
